$(document).ready(function(){
  $( function() {
    
    var blackoutDates = ["2024-12-23","2024-12-24","2024-12-25","2024-12-26","2025-01-01","2025-02-17","2025-04-18","2025-04-21","2025-05-19","2025-07-01","2025-08-04","2025-09-01","2025-10-13","2025-12-25","2025-12-26","2026-01-01"]
    
    $('#cateringEventDate').datepicker( {
        minDate: '+3d',
        maxDate: '+1M',
      	beforeShowDay: function(date){
          var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
          return [ blackoutDates.indexOf(string) == -1 ];
      	}
    });
	// Don't think this is needed anymore, because we are ditching the select menu.
    // toggleMenu();
  });

  // Don't think this is needed anymore.
//   $('#catering-menu-select').on('change', function() {
//       toggleMenu();
//   });


  // New markup structure.
  $('.CateringItem__Input input').on('change',function() {
    updateOrder();
  });

    // tr.catering-item-field input
//   $('.catering-item-field input').on('change',function() {
//     updateOrder();
//   });

// Don't think this is needed anymore, we arent using the select menu.
//   function toggleMenu() {
    
//     var subMenuId = $('#catering-menu-select').find(":selected").data().menu
    
//     $('.catering-menu').hide();
//     $(subMenuId).show();
//   }

  function updateOrder() {

    var orderLineItems      = '';
    var orderLineItemsEmail = ''
    var orderSubTotal       = 0;

	// New variables.
	var orderSummaryListItems = '';
    
	// input.catering-item
    $('.catering-item').each( function() {     
      var item = $(this);
      
      if ( item.val() > 0 ) { 
        orderLineItems += '<li class="catering-form__summary-item"> <span>' + item[0].dataset.itemName + '</span><span class="catering-form__summary-item-price">(' + item.val() + ') $' + item[0].dataset.itemPrice + '</span></li>';

		// New.
		orderSummaryListItems += '<div class="CateringSummaryList__Item"><div>' + item[0].dataset.itemName + '</div><div class="Qty">' + item.val() + '</div><div class="Price">$' + item[0].dataset.itemPrice * item.val() + '</div></div>';

        // orderLineItemsEmail += item[0].dataset.itemName + ' (' + item.val() + ') $' + item[0].dataset.itemPrice + '&#13;&#10;'
		orderLineItemsEmail += item[0].dataset.itemName + ' (' + item.val() + ') $' + item[0].dataset.itemPrice + '\r\n';
      }
      
      orderSubTotal += item.val() * item[0].dataset.itemPrice;

    });
    
    $("#cateringOrderSummary").val('');
    $(".catering-form__summary-items").empty();
    $(".catering-form__subtotal").empty()
    $(".catering-form__total").empty()

	// New.
	$(".CateringSummaryList").empty();
	$(".CateringSummarySubtotal .Subtotal").empty();

    if (orderLineItems !== '') {
      $(".catering-form__summary-placeholder").hide();
      $(".catering-form__summary-items").append(orderLineItems);
      $("#cateringOrderSummary").val(orderLineItemsEmail);
      $(".catering-form__subtotal").append('$' + orderSubTotal.toFixed(2));
      $(".catering-form__total").append('$' + (orderSubTotal * 1.13).toFixed(2));
    } else {
      $(".catering-form__summary-placeholder").show();
      $(".catering-form__subtotal").append('$0');
      $(".catering-form__total").append('$0');
    }

	if (orderSummaryListItems !== '') {
		// $(".catering-form__summary-placeholder").hide();
		$(".CateringSummaryList").append(orderSummaryListItems);

		$(".CateringSummarySubtotal .Subtotal").append('$' + orderSubTotal.toFixed(2) + '<div><p><strong>Catering total</strong> (+ applicable taxes)</p></div>');
		// $("#cateringOrderSummary").val(orderLineItemsEmail);
		// $(".catering-form__subtotal").append('$' + orderSubTotal.toFixed(2));
		// $(".catering-form__total").append('$' + (orderSubTotal * 1.13).toFixed(2));
	  }


  }
});
  

